import React, { Component } from "react";
import IScroll from "react-iscroll";
import iScroll from "iscroll/build/iscroll-probe";
import { hasClientFeature } from "../../helpers/client";
import Scrollable from "../Scrollable/Scrollable";

import styles from "./Keyboard.css";
import KeyContainer from "./KeyContainer";

class Keyboard extends Component {
  state = { allowDnd: true };

  render = () => {
    const { allowDnd } = this.state;
    const { setValue, alphabet, hint } = this.props;
    const keys = alphabet.map(char => (
      <li className={styles.key} key={char}>
        <KeyContainer
          char={char}
          setValue={setValue}
          hint={hint}
          draggable={allowDnd}
        />
      </li>
    ));

    const keyboard = (
      <ul
        className={`${styles.keyboard} ${alphabet.length > 15 && styles.large}`}
      >
        {keys}
      </ul>
    );

    return (
      <Scrollable className={styles.wrapper}>
        {hasClientFeature("touchevents") ? (
          <IScroll
            iScroll={iScroll}
            options={{
              scrollX: true,
              scrollY: false,
              disableTouch: false,
              eventPassthrough: "vertical",
              mouseWheel: false,
              disablePointer: true,
              disableMouse: true
            }}
            onScrollStart={() => {
              this.setState({ allowDnd: false });
            }}
            onScrollEnd={() => {
              this.setState({ allowDnd: true });
            }}
          >
            {keyboard}
          </IScroll>
        ) : (
          keyboard
        )}
      </Scrollable>
    );
  };
}

Keyboard.defaultProps = {
  alphabet: []
};

export default Keyboard;



// WEBPACK FOOTER //
// ./src/components/Keyboard/Keyboard.js